import { Stack, Typography } from '@mui/material';
import { toTitleCase } from '../../common/utils';
import { getCampusFromSiteCode } from '../utils';

//θ(1) Returns all the columns of the datagrid
export const getColumns = () => {
  return [
    {
      field: 'LASTNAME',
      headerName: 'Last Name',
      width: 150,
      valueGetter: (value, row) => {
        const lastName = row.NAME.split(',')[0];
        return lastName;
      },
    },
    {
      field: 'FIRSTNAME',
      headerName: 'First and Middle Name',
      width: 250,
      valueGetter: (value, row) => {
        const firstName = row.NAME.split(',')[1];
        return firstName;
      },
    },
    {
      field: 'MIDAS',
      headerName: 'MIDAS',
      width: 150,
    },
    {
      field: 'SPRIDEN_ID',
      headerName: 'Student ID',
      width: 150,
    },
    {
      field: 'EMAIL',
      headerName: 'Email',
      width: 150,
    },
    {
      field: 'SGBSTDN_LEVL_CODE',
      headerName: 'Level',
      width: 150,
    },
    {
      field: 'SGBSTDN_STYP_CODE',
      headerName: 'Student Type',
      width: 200,
    },
    {
      field: 'CLAS_CODE',
      headerName: 'Class',
      width: 150,
    },
    {
      field: 'SGBSTDN_DEGC_CODE_1',
      headerName: 'Degree',
      width: 150,
    },
    {
      field: 'SGBSTDN_SITE_CODE',
      headerName: 'Site',
      width: 150,
    },
    {
      field: 'CAMPUS',
      headerName: 'Campus',
      valueGetter: (value, row) => getCampusFromSiteCode(row.SGBSTDN_SITE_CODE),
      width: 150,
    },
    {
      field: 'DEPT_CODE',
      headerName: 'Department',
      width: 200,
      renderCell: (params) => {
        const departments = params.row.DEPARTMENTS;
        return (
          <Stack direction={'column'} gap={1}>
            {departments.map((department) => {
              return (
                <Typography variant="p" sx={{ whiteSpace: 'nowrap' }} noWrap>
                  {department}
                </Typography>
              );
            })}
          </Stack>
        );
      },
      valueGetter: (value, row) => {
        const departments = row.DEPARTMENTS;
        return departments.join(' ');
      },
    },
    {
      field: 'TYPE',
      headerName: 'Type',
      width: 150,
      renderCell: (params) => {
        const types = params.row.TYPES;
        return (
          <Stack direction={'column'} gap={1}>
            {types.map((type) => {
              return (
                <Typography variant="p" sx={{ whiteSpace: 'nowrap' }} noWrap>
                  {type}
                </Typography>
              );
            })}
          </Stack>
        );
      },
      valueGetter: (value, row) => {
        const types = row.TYPES;
        return types.join(' ');
      },
    },
    {
      field: 'FIELDOFSTUDY',
      headerName: 'Field of Study',
      width: 200,
      renderCell: (params) => {
        const fields = params.row.FIELD_OF_STUDIES;
        return (
          <Stack direction={'column'} gap={1}>
            {fields.map((field) => {
              return (
                <Typography variant="p" sx={{ whiteSpace: 'nowrap' }} noWrap>
                  {field}
                </Typography>
              );
            })}
          </Stack>
        );
      },
      valueGetter: (value, row) => {
        const fields = row.FIELD_OF_STUDIES;
        return fields.join(' ');
      },
    },
    {
      field: 'SGBSTDN_TERM_CODE_EFF',
      headerName: 'Term Started',
      width: 200,
    },
    {
      field: 'ENROLLED',
      headerName: 'Enrolled',
      width: 150,
    },
  ];
};
